import { BreadcrumbLink } from '../../../../shared/components/breadcrumbs/BreadcrumbLink';
import { individualPaths } from '../../../../../routes/employer/paths/individual.paths';

export const IndividualDetailsBreadcrumb = (): React.ReactElement<any, any> | null => (
    <BreadcrumbLink to={individualPaths.details}>Details</BreadcrumbLink>
);
